import React from 'react'
import { BookOpen, FileText, Search, Sparkles } from 'lucide-react'
import { agentColors } from './agentChatLayout'
import './agentStatusAnimations.css'

function activityKind(activity) {
  const kind = activity?.kind
  if (kind) return kind
  if (activity?.label?.startsWith('Reviewing')) return 'reviewing'
  if (activity?.label?.startsWith('Asking') || activity?.label?.startsWith('Sending results')) {
    return 'calling_model'
  }
  if (activity?.label?.startsWith('Selected')) return 'tool_selected'
  if (activity?.label?.includes('Searching') || activity?.label?.includes('Querying')) {
    return 'tool_running'
  }
  return 'generic'
}

function ActivityIcon({ activity }) {
  const kind = activityKind(activity)
  const active = activity?.status !== 'error'
  const boxClass = active ? 'agent-status-icon-box agent-status-icon-active' : 'agent-status-icon-box'

  if (activity?.status === 'error') {
    return (
      <span className="agent-status-icon-box" style={{ color: agentColors.danger }}>
        !
      </span>
    )
  }

  const iconProps = { size: 14, strokeWidth: 2, 'aria-hidden': true }

  if (kind === 'reviewing' || kind === 'planning' || kind === 'analysing' || kind === 'calling_model') {
    return (
      <span className={boxClass} style={{ color: agentColors.accent }}>
        <Sparkles {...iconProps} />
      </span>
    )
  }
  if (kind === 'tool_selected' || kind === 'tool_running') {
    const label = activity?.label || ''
    if (label.includes('wiki') || label.includes('Wiki')) {
      return (
        <span className={boxClass} style={{ color: agentColors.accent }}>
          <BookOpen {...iconProps} />
        </span>
      )
    }
    if (label.includes('document') || label.includes('Document') || label.includes('Reading')) {
      return (
        <span className={boxClass} style={{ color: agentColors.accent }}>
          <FileText {...iconProps} />
        </span>
      )
    }
    return (
      <span className={boxClass} style={{ color: agentColors.accent }}>
        <Search {...iconProps} />
      </span>
    )
  }

  return (
    <span className={boxClass} style={{ color: agentColors.accent }}>
      <Sparkles {...iconProps} />
    </span>
  )
}

/**
 * Single live activity line during an agent turn (ChatGPT-style).
 * activity: { id, label, kind, status?: 'active'|'error' }
 */
export default function AgentStatusStrip({ activity }) {
  if (!activity?.label) return null

  return (
    <div
      style={{
        padding: '10px 14px',
        borderRadius: 10,
        background: 'rgba(255,255,255,0.45)',
        backdropFilter: 'blur(8px)',
        border: `1px solid ${agentColors.borderSoft}`,
        marginBottom: 0,
        minHeight: 44,
      }}
    >
      <div
        key={activity.id}
        className="agent-activity-fade"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          fontSize: 13,
          color:
            activity.status === 'error'
              ? agentColors.danger
              : agentColors.accent,
        }}
      >
        <ActivityIcon activity={activity} />
        <span>{activity.label}</span>
      </div>
    </div>
  )
}
